import type {
  CreateWheelRaffleRequest,
  RaffleTier,
  RaffleVisibility,
} from "entities/wheel-raffle";
import { DEFAULT_DURATION_SEC } from "./duration";
import { getTiersFrom } from "./tierThreshold";

// Деньги и количество — строками, как в инпутах.
export interface RaffleFormValues {
  prizePool: string;
  winnersCount: string;
  durationSec: number;
  symbols: string[];
  volume: string;
  minTier: string; //tier_code: участвует он и все выше
  visibility: RaffleVisibility;
  inviteCode: string;
}

export type RaffleField = keyof RaffleFormValues;

export const EMPTY_VALUES: RaffleFormValues = {
  prizePool: "",
  winnersCount: "",
  durationSec: DEFAULT_DURATION_SEC,
  symbols: [],
  volume: "",
  minTier: "",
  visibility: "open",
  inviteCode: "",
};

// "10.5" → "10.50": бэк ждёт деньги строкой с двумя знаками.
const toUsdt = (value: string): string => {
  const [whole, fraction = ""] = value.trim().split(".");
  return `${Number(whole)}.${fraction.padEnd(2, "0")}`;
};

// ISO8601 UTC без миллисекунд.
const toUtcIso = (timestamp: number): string =>
  new Date(timestamp).toISOString().replace(/\.\d{3}Z$/, "Z");

// Розыгрыш стартует сразу и длится durationSec.
export const toCreateRequest = (
  values: RaffleFormValues,
  tiers: RaffleTier[],
  now: number = Date.now(),
): CreateWheelRaffleRequest => {
  const startsAt = Math.floor(now / 1000) * 1000;
  const isPrivate = values.visibility === "private";
  return {
    prize_pool_usdt: toUsdt(values.prizePool),
    winners_count: Number(values.winnersCount),
    starts_at: toUtcIso(startsAt),
    ends_at: toUtcIso(startsAt + values.durationSec * 1000),
    allowed_participant_tiers: getTiersFrom(tiers, values.minTier),
    symbols: values.symbols,
    volume_usdt: toUsdt(values.volume),
    visibility: values.visibility,
    ...(isPrivate && { invite_code: values.inviteCode.trim() }),
  };
};
